// authFetch wraps fetch with automatic 401 handling (clear session + redirect to /login)
export async function authFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const token = localStorage.getItem('jwtToken')
  const csrfMatch = document.cookie.match(/(?:^|;\s*)csrf_token=([^;]*)/)
  const csrfToken = csrfMatch ? decodeURIComponent(csrfMatch[1]) : ''

  const headers: Record<string, string> = {
    ...((options.headers as Record<string, string>) || {}),
  }

  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }
  if (csrfToken && options.method && !['GET', 'HEAD', 'OPTIONS'].includes(options.method)) {
    headers['X-CSRF-Token'] = csrfToken
  }

  const res = await fetch(url, { ...options, headers })

  if (res.status === 401) {
    localStorage.removeItem('jwtToken')
    localStorage.removeItem('username')
    localStorage.removeItem('role')
    // Don't redirect if already on login/register to avoid redirect loops
    const path = window.location.pathname
    if (path !== '/login' && path !== '/register') {
      window.location.href = '/login'
    }
    throw new Error('Session expired')
  }

  return res
}
